var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-group',{staticClass:"pa-4 pr-0 pl-0",attrs:{"active-class":"success","show-arrows":""}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }